export const PARTNER_ROW = 37;
export const COT_ARTICLE = 41;
export const COT_QUIZ_IMAGEGRID = 45;
export const COT_COMPARISON = 46;
export const COT_REVIEW = 47;
export const COT_SIDEBAR = 48;
export const COT_TESTIMONIAL = 49;
export const COT_DISCOUNT_BUTTON = 50;
export const COT_CTA_SUMMARY = 51;
export const COT_PODIUM = 52;
export const COT_FEATURED_PARTNER = 54;
export const COT_BOTTOM_BANNER = 55;
export const COT_VIDEO_GRID = 56;
export const COT_EXIT_OVERLAY = 57;
export const COT_QUESTIONNAIRE = 58;
export const COT_QUESTIONNAIRE_IMAGE_GRID_TWO = 59;
export const COT_QUESTIONNAIRE_ON_PAGE = 60;
export const COT_COUNTDOWN_OFFER = 62;
export const COT_QUESTIONNAIRE_NEW = 65;
export const COT_QUESTIONNAIRE_ZETA = 65;
export const COT_SIDE_BANNER = 67;
export const COT_COUPON = 68;
export const COT_DISCOUNT_BUTTON_QUIZ = 70;
export const COT_QUESTIONNAIRE_SIMPLE = 71;
export const COT_SIDEBAR_AD_BANNER = 74;
export const COT_POPUP_DEAL = 76;
export const COT_QUESTIONNAIRE_DYNAMIC = 80;
export const COT_POPUP_BANNER = 82;
export const COT_STICKY_BANNER = 83;
export const COT_TOP5_RANKING_EASY_SIGN_UP = 84;
export const COT_TOP5_QUIZ_EASY_SIGN_UP = 85;
export const COT_RETURN_POPUP = 87;
export const COT_SIDEBAR_BILLBOARD = 88;
export const COT_QUESTIONNAIRE_ALPHA = 92;
export const COT_QUIZ_CHATBOT = 93;
